import styled, {css} from 'styled-components'

export const StyledUserDetailsEventsWrapper = styled.div(
    () => css`
        display: grid;
        grid-template-rows: auto minmax(0, 1fr);
        height: 100%;
    `
)

export const StyledSelectCell = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        padding: ${spacing * 0.5}px;
    `
)
